// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".region-wrapper[data-v-dfea79e2] {\n  position: relative;\n  padding: 5px;\n  border: 2px solid transparent;\n}\n.region-wrapper.highlight-instance-row[data-v-dfea79e2] {\n  border-radius: 10px;\n}\n.region-text[data-v-dfea79e2] {\n  line-height: 1.363em;\n  vertical-align: middle;\n  font-size: 13px;\n}\n.status-col[data-v-dfea79e2] {\n  min-height: 70px;\n}\n.disabled-item[data-v-dfea79e2] {\n  color: #A6A4A6;\n}", ""]);
// Exports
module.exports = exports;
